import data from "@iconify-icons/mdi/facebook";
import { createContext, useCallback, useState } from "react";
import API from "services/api";

export const PortalManagementContext = createContext({
  documents: [],
  dataDocument: {},
  categories: [],
  numRow: 0,
  listEditor: [],
  popups: [],
  events: [],
  eventCategories: [],
  dataEvent: {},
  surveyQuestions: [],
  sponsors: [],
  faqs: [],
  dataFaq: {},
  dataSitemap: {},
  sitemaps: [],
  unstructuredSitemap: [],
  totalCount: 0,
  dataSurveyQuestion: {},
  surveyQuestions: [],
  dataBannerSlider: {},
  bannerSliders: [],
  dataPage: {},
  pages: [],
  organization: {},

  getOrganization: () => {},
  getStructuredPages: () => {},
  getPages: () => {},
  getDataPage: () => {},
  getAllBannerSlider: () => {},
  getDataBannerSlider: () => {},
  getDataSurveyQuestion: () => {},
  getPopups: () => {},
  getUnstructuredSitemaps: () => {},
  getAllSitemap: () => {},
  getDataSitemap: () => {},
  getDocumentCategories: () => {},
  getListEditorDocumentCategories: () => {},
  getDocuments: () => {},
  getDataDocument: () => {},
  getSurveyQuestions: () => {},
  getEvents: () => {},
  getEventCategories: () => {},
  getFAQs: () => {},
  getDataFAQ: () => {},
  getDataEvent: () => {},
  getSponsor: () => {},
  getDataSponsor: () => {},
});

const PortalManagementProvider = (props) => {
  const [dataSitemap, setDataSitemap] = useState({});
  const [sitemaps, setSitemaps] = useState([]);
  const [unstructuredSitemap, setUnstructuredSitemap] = useState([]);
  const [dataBannerSlider, setDataBannerSlider] = useState({});
  const [bannerSliders, setBannerSliders] = useState([]);
  const [dataSurveyQuestion, setDataSurveyQuestion] = useState({});
  const [dataPage, setDataPage] = useState({});
  const [surveyQuestions, setSurveyQuestions] = useState([]);
  const [popups, setPopups] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [pages, setPages] = useState([]);
  const [dataFaq, setDataFaq] = useState({});
  const [events, setEvents] = useState([]);
  const [dataEvent, setDataEvent] = useState({});
  const [eventCategories, setEventCategories] = useState([]);
  const [sponsors, setSponsors] = useState([]);
  const [organization, setOrganization] = useState([]);

  // documents
  const [documents, setDocuments] = useState([]);
  const [dataDocument, setDataDocument] = useState({});
  const [categories, setCategories] = useState([]);
  const [listEditor, setListEditor] = useState([]);

  const [totalCount, setTotalCount] = useState(0);
  const [numRow, setNumRow] = useState(0);

  const getOrganization = useCallback(
    async (params) => {
      await API.getAllOrganization(params)
        .then((res) => {
          const {
            data,
            totalItems,
            totalCount: _totalCount,
            numRow: _numRow,
          } = res.data;

          setOrganization(data);
          setTotalCount(_totalCount);
          setNumRow(_numRow);
        })
        .catch((err) => console.log("err", err));
    },
    [organization],
  );

  const getStructuredPages = useCallback(
    async (params) => {
      await API.getStructuredNestedPage(params)
        .then((res) => {
          const {
            data,
            totalItems,
            totalCount: _totalCount,
            numRow: _numRow,
          } = res.data;

          setPages(data);
          setTotalCount(_totalCount);
          setNumRow(_numRow);
        })
        .catch((err) => console.log("err", err));
    },
    [pages],
  );

  const getPages = useCallback(
    async (params) => {
      await API.getAllPage(params)
        .then((res) => {
          const {
            data,
            totalItems,
            totalCount: _totalCount,
            numRow: _numRow,
          } = res.data;

          setPages(data);
          setTotalCount(_totalCount);
          setNumRow(_numRow);
        })
        .catch((err) => console.log("err", err));
    },
    [pages],
  );

  const getDataPage = useCallback(
    async (id, params) => {
      await API.getPage(id, params)
        .then((res) => {
          const { data } = res;
          // const data = _data;
          setDataPage(data);
        })
        .catch((err) => console.log("err", err));
    },
    [dataPage],
  );

  // Documents
  const getDocumentCategories = useCallback(async (params) => {
    await API.getDocumentCategories(params)
      .then((res) => {
        const { data, totalItems, totalCount: _totalCount } = res.data;
        setCategories(data);
        setTotalCount(_totalCount);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getListEditorDocumentCategories = useCallback(
    async (id, params) => {
      await API.getListEditorDocumentCategories(id, params)
        .then((res) => {
          const { type } = params;
          const { data } = res;
          setListEditor(data[type]);
        })
        .catch((err) => console.log("err", err));
    },
    [listEditor],
  );

  const getDocuments = useCallback(async (params) => {
    await API.getAllDocument(params)
      .then((res) => {
        const {
          data,
          totalItems,
          totalCount: _totalCount,
          numRow: _numRow,
        } = res.data;

        setDocuments(data);
        setTotalCount(_totalCount);
        setNumRow(_numRow);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getDataDocument = useCallback(async (id, params) => {
    await API.getDocument(id, params)
      .then((res) => {
        const { data } = res;
        // const data = _data;
        setDataDocument(data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  // FAQ
  const getFAQs = useCallback(async (params) => {
    await API.getAllFAQ(params)
      .then((res) => {
        const { data } = res.data;
        setFaqs(data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getDataFAQ = useCallback(async (id, params) => {
    await API.getFAQ(id, params)
      .then((res) => {
        console.log("rs", res.data);
        const { data: _data } = res;
        const data = _data[0];
        setDataFaq(data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  // Survey Questions

  const getSurveyQuestions = useCallback(
    async (params) => {
      await API.getAllSurveyQuestion(params)
        .then((res) => {
          const { data, total } = res.data;
          // console.log("total", total);
          setTotalCount(total);
          setSurveyQuestions(data);
        })
        .catch((err) => console.log("err", err));
    },
    [surveyQuestions],
  );

  // Events
  const getEvents = useCallback(async (params) => {
    await API.getAllEvent(params)
      .then((res) => {
        const { data, totalItems, totalCount: _totalCount } = res.data;

        setEvents(data);
        setTotalCount(_totalCount);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getDataEvent = useCallback(async (id, params) => {
    await API.getEvent(id, params)
      .then((res) => {
        // console.log("rs", res.data);
        const data = res.data;
        setDataEvent(data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getEventCategories = useCallback(async (params) => {
    await API.getEventCategories(params)
      .then((res) => {
        const { data, totalItems, totalCount: _totalCount } = res.data;

        setEventCategories(data);
        setTotalCount(_totalCount);
      })
      .catch((err) => console.log("err", err));
  }, []);

  // Sponsoers
  const getSponsor = useCallback(async (params) => {
    await API.getAllSponsor(params)
      .then((res) => {
        const data = res.data;
        setSponsors(data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getDataSponsor = useCallback(async (id, params) => {
    await API.getSponsor(id, params)
      .then((res) => {
        // console.log("rs", res.data);
        const data = res.data;
        // setDataSponsor(data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  // Sitemaps
  const getUnstructuredSitemaps = useCallback(
    async (params) => {
      await API.getUnstructuredSitemaps(params)
        .then((res) => {
          const { data, total } = res.data;
          setUnstructuredSitemap(data);
        })
        .catch((err) => console.log("err", err));
    },
    [unstructuredSitemap],
  );

  const getAllSitemap = useCallback(
    async (params) => {
      await API.getAllSitemap(params)
        .then((res) => {
          const { data, total } = res.data;
          // console.log("total", total);
          setTotalCount(total);
          setSitemaps(data);
        })
        .catch((err) => console.log("err", err));
    },
    [sitemaps],
  );

  const getDataSitemap = useCallback(async (id, params) => {
    await API.getSitemap(id, params)
      .then((res) => {
        const { data } = res.data;
        const category = data[0].category?._id;
        const newData = { ...data[0], category };
        setDataSitemap(newData);
      })
      .catch((err) => console.log("err", err));
  }, []);

  // Banner Slider
  const getAllBannerSlider = useCallback(async (params) => {
    await API.getAllBanner(params)
      .then((res) => {
        const { data } = res;
        // console.log("total", total);
        // setTotalCount(total);
        setBannerSliders(data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getDataBannerSlider = useCallback(async (id, params) => {
    await API.getBanner(id, params)
      .then((res) => {
        const { data } = res;
        const category = data[0].category?._id;
        const newData = { ...data[0], category };
        setDataBannerSlider(newData);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getDataSurveyQuestion = useCallback(async (id, params) => {
    await API.getSurveyQuestion(id, params)
      .then((res) => {
        const { data } = res.data;
        const category = data[0].category?._id;
        const newData = { ...data[0], category };
        setDataSurveyQuestion(newData);
      })
      .catch((err) => console.log("err", err));
  }, []);

  // Popup
  const getPopups = useCallback(async (params) => {
    await API.getPopups(params)
      .then((res) => {
        const { data, total } = res.data;
        // console.log("total", total);
        setTotalCount(total);
        setPopups(data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  return (
    <PortalManagementContext.Provider
      value={{
        documents,
        dataDocument,
        categories,
        numRow,
        listEditor,
        popups,
        events,
        eventCategories,
        dataEvent,
        surveyQuestions,
        sponsors,
        faqs,
        dataFaq,
        dataSitemap,
        sitemaps,
        totalCount,
        dataSurveyQuestion,
        surveyQuestions,
        dataBannerSlider,
        bannerSliders,
        dataPage,
        pages,
        organization,
        unstructuredSitemap,

        getUnstructuredSitemaps,
        getOrganization,
        getStructuredPages,
        getPages,
        getDataPage,
        getAllBannerSlider,
        getDataBannerSlider,
        getDataSurveyQuestion,
        getPopups,
        getAllSitemap,
        getDataSitemap,
        getDocumentCategories,
        getListEditorDocumentCategories,
        getDocuments,
        getDataDocument,
        getSurveyQuestions,
        getEvents,
        getEventCategories,
        getDataEvent,
        getFAQs,
        getDataFAQ,
        getDataEvent,
        getSponsor,
        getDataSponsor,
      }}
      {...props}
    />
  );
};

export default PortalManagementProvider;
